<template>
  <v-app id="inspire">
    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      v-if="logueado"
      fixed
      app
    >
      <v-list dense>
        <template v-if="esAdministrador || esAnalista || esActualizador">
            <v-flex xs12>
              <v-img
                src="https://www.vecol.com.co/themes/front/img/logo.png"
                class="my-3"
                contain
                height="100"
                alt="Vecol" title="Vecol" 
              ></v-img>
            </v-flex>

          <v-list-item :to="{ name: 'Inicio'}">
            <v-list-item-action>
              <v-icon><mdi-pencil></mdi-pencil></v-icon>
            </v-list-item-action>
            <v-list-item-title>
              APP de Captura de Datos
            </v-list-item-title>
          </v-list-item>          
        </template>
        <template  v-if="esAdministrador || esAnalista || esActualizador">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  Datos Generales
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'perspectivas'}">
              <v-list-item-action>
                <v-spacer></v-spacer>
                <v-icon>mdi-codepen</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Perspectivas
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'objetivos'}">
              <v-list-item-action>
                <v-spacer></v-spacer>
                <v-icon>mdi-alert-circle-outline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Objetivos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </v-list-group>
        </template>
      
        <template  v-if="esAdministrador">
            <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  Accesos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'roles'}">
              <v-list-item-action>
                <v-spacer></v-spacer>
                <v-icon>mdi-home</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Roles
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'usuarios'}">
              <v-list-item-action>
                <v-spacer></v-spacer>
                <v-icon>mdi-home</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Usuarios
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
     
      </v-list>
 
    </v-navigation-drawer>
    <v-app-bar 
      :clipped-left="$vuetify.breakpoint.lgAndUp"  
      app 
      color="primary"  
      dark 
      fixed
     >
     

      <v-toolbar-title style="width: 800px" class="ml-0 pl-1">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">Web Capture Cuadro de Mando Integral </span>
      </v-toolbar-title>
      <v-spacer></v-spacer> 
      <v-btn @click="salir" v-if="logueado" icon>
        <v-icon>mdi-logout</v-icon> Salir
      </v-btn>
      <v-btn :to="{name: 'login'}" v-else>
        <v-icon>mdi-apps</v-icon> Login
      </v-btn>  
     </v-app-bar>
    <v-content>

    <v-container  fluid fill-height>
        <v-slide-y-transition mode="out-in">
          <router-view/>
        </v-slide-y-transition>
      </v-container>
    </v-content>

    <v-footer dark height="auto">
      <v-layout justify-left>
        <v-flex text-xs-left>
          <v-card flat tile class="white--text">
            <img src="https://vecol-webcapture.gpstrategy.com.co/img/appVecol-04.png" class="img-fluid" alt="">     
          </v-card>
        </v-flex>
                  <div>
                    <a color="green" href="https://www.gpstrategy.com.co" > www.gpstrategy.com.co </a>
                  </div>
      </v-layout>
    </v-footer>

  </v-app>
</template>


<script>

export default {
  name: 'App',
  data () {
    return {
      clipped: false,
      drawer: null,
      fixed: false,
      items: [{
        icon: 'bluble_chart',
        title: 'Inspire'
      }],
      miniVariant: false,
      rigth: true,
      rigthDrawer: false,
      title: 'Vuetify.js'
    }
  },
  computed:{
    data(){
        return {
            nombre1: '',
            email1: ''
        }
    },
    logueado(){
      return this.$store.state.usuario;  
      nombre1  = this.$store.usuario.nombre;
      email1 = this.$store.usuario.email;
  },
  esAdministrador(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'Administrador'; 
    },
  esAnalista(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'Analizador'; 
    },
  esActualizador(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'Actualizador'; 
    },
  },  
  create(){
    this.$store.dispatch("autoLogin");
  },
  methods:{
    salir(){
      this.$store.dispatch("salir");
    }
  }
}
</script>
